module.exports = __webpack_public_path__ + "img/s3.28cb74ab.webp";